import React from "react";
import { Edit, SimpleForm, useNotify } from "react-admin";

// Components
import { EditControllerForm } from "./Edit/EditControllerForm";
import EditToolbar from "../EditToolbar";

export const EditComponent: React.FC = () => {
  const notify = useNotify();

  const onSuccess = () => {
    notify(`Controller updated successfully`, { type: "success" });
  };

  const onError = (error: any) => {
    notify(error.message, { type: "error" });
  };

  return (
    <Edit mutationMode="pessimistic" mutationOptions={{ onSuccess, onError }}>
      <SimpleForm
        mode="onBlur"
        reValidateMode="onBlur"
        toolbar={<EditToolbar name="controller" resource="controllers" />}
      >
        <EditControllerForm />
      </SimpleForm>
    </Edit>
  );
};
